// extracted by mini-css-extract-plugin
export var actions = "_tn-4";
export var item = "_tn-1";
export var price = "_tn-3";
export var quantity = "_tn-2";
export var table = "_tn-0";